import { Component } from '@angular/core';
import { ShowComponent } from '../../common/component/show.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Data2Service } from '../../common/data2.service';
import { DataBagService } from '../../common/data-bag.service';
import { UuidService } from '../../common/uuid.service';
import { DateService } from '../../common/date.service';
import { InfoboxService } from '../../common/infobox/infobox.service';
import { QuestionService } from '../../common/question-dialog/question-dialog.service';
import { LoaderService } from '../../common/loader/loader.service';
import { LockerService } from '../../common/locker.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../../services/service.service';
import { DatePipe } from '@angular/common';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
@Component({
	selector: 'app-season',
	templateUrl: './season.component.html',
	styleUrls: ['./season.component.scss'],
	providers: [{ provide: MAT_DATE_LOCALE, useValue: 'pl-PL' }],
})
export class CodebookSeasonComponent extends ShowComponent {
	protected apiType = 'bag';
	protected apiUrlAdd = '/reservation/season/';
	protected parentComponent = 'codebook/season_list';
	parentLocationSet = [];
	codebook = null;

	constructor(
		protected api: Data2Service,
		protected bag: DataBagService,
		protected uuid: UuidService,
		protected date: DateService,
		protected infobox: InfoboxService,
		protected question: QuestionService,
		protected loader: LoaderService,
		protected locker: LockerService,
		protected route: ActivatedRoute,
		protected router: Router,
		protected service: ServiceService,
		private readonly formBuilder: FormBuilder,
		private readonly datePipe: DatePipe,
		private readonly dateAdapter: DateAdapter<Date>,
	) {
		super(api, bag, uuid, date, infobox, question, loader, locker, route, router);
		this.dateAdapter.setLocale('pl-PL');
	}

	protected pageTitleGenerate(): string {
		return `Słowniki ->
			${this.codebook.name}
			 ->
			${this.data.name}
			(ID:
			${this.data.id}
			)`;
	}

	myForm: FormGroup;
	protected loadBefore(): void {
		this.bag.get('/reservation/season/', (result, error) => {
			this.parentLocationSet = result.results;
			this.loadData();
		});
		this.bag.get('/codebook/16/', (result, error) => {
			this.codebook = result;

			this.loadData();
		});
	}

	protected afterLoadData() {
		this.myForm = this.formBuilder.group({
			id: [this.data.id],
			name: [this.data.name, Validators.required],
			dateRange: this.formBuilder.group({
				lower: [this.data.dateRange.lower, Validators.required],
				upper: [this.data.dateRange.upper, Validators.required],
			}),
		});
	}

	data = {
		id: null,
		name: null,
		dateRange: { lower: null, upper: null },
	};

	protected submitAfter(): void {
		this.router.navigate([this.parentComponent]);
	}

	private transformDate(date: Date): string {
		return this.datePipe.transform(date, 'YYYY-MM-dd');
	}

	protected checkFormBeforeSubmit() {
		this.myForm.markAllAsTouched();
		if (this.myForm.invalid) {
			return;
		}
		const { dateRange, ...otherFormValues } = this.myForm.value;
		this.data = {
			...otherFormValues,
			dateRange: {
				lower: this.transformDate(new Date(dateRange.lower)),
				upper: this.transformDate(new Date(dateRange.upper)),
			},
		};
		this.submit();
	}

	protected getApiUrl(): string {
		return '/reservation/season/' + this.data.id + '/';
	}
}
